var _circle, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPauseAudio = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#3B5A7A"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 9,
  width: 3,
  height: 12,
  rx: 1.5,
  fill: "#F4F6F8"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 17,
  y: 9,
  width: 3,
  height: 12,
  rx: 1.5,
  fill: "#F4F6F8"
})));
export default SvgPauseAudio;